/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DropdownTriggerDirective } from './dropdown-trigger.directive';
import { DropdownComponent } from './dropdown.component';
import { A11yModule } from '@angular/cdk/a11y';


@NgModule({
  declarations: [
    DropdownComponent,
    DropdownTriggerDirective
  ],
  imports: [
    CommonModule,
    OverlayModule,
    A11yModule
  ],
  exports: [
    DropdownComponent,
    DropdownTriggerDirective
  ]
})
export class DropdownModule {}
